import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const dropServers = (action$) =>
    action$.pipe(
        ofType(actionTypes.DROP_SERVERS),
        switchMap(() => {
            return [
                {
                    type: actionTypes.SAVE_SERVER_MANAGEMENT_LIST,
                    payload: {
                        serverManagementList: []
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_DELETE_REDLIKE_SERVERS
                    },
                    method: handlers.DELETE_REDLIKE_SERVERS,
                    tabId: 0
                }
            ];
        })
    );

export default [dropServers];
